module.exports = __webpack_public_path__ + "static/media/icon-check-orange.a5783ba3.svg";